class CartNotification extends HTMLElement {
  constructor() {
    super()

    this.miniCart = document.querySelector(".mini-cart")
  }

  open() {
    this.miniCart.classList.toggle("-open")
    document.body.classList.toggle("-modal-open")
  }

  close() {}

  async renderContents(parsedState) {
    const self = this;
    if (parsedState.sections == null) {
      try {
        fetch(`${Shopify.routes.root + 'cart'}?sections=${this.getSectionsToRender().map(section => section.id)}`)
          .then(response => response.json())
          .then(data => {
            parsedState.sections = data
            console.log('await')
            this.productId = parsedState.id
            this.getSectionsToRender().forEach((section) => {
              document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.id],
                section.selector
              )
            })
        
            this.open()
          })
      } catch (error) {
        console.log('getParseState',  error)
        this.productId = parsedState.id
        this.getSectionsToRender().forEach((section) => {
          document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector
          )
        })
    
        this.open()
      }
    }else{
      console.log('now')
      this.productId = parsedState.id
      this.getSectionsToRender().forEach((section) => {
        document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        )
      })
  
      this.open()
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-icon-bubble",
      },
      {
        id: "mini-cart-badge",
      },
      {
        id: "main-cart-items",
        selector: "#main-cart-items",
      },
      {
        id: "main-cart-footer",
        selector: "#main-cart-footer",
      },
    ]
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML
  }

  setActiveElement(element) {
    this.activeElement = element
  }
}

customElements.define("cart-notification", CartNotification)
